const waluta = { t: 'Waluta', name: 'waluta', hint: { url: '/currency' }}
export default waluta